<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="8" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>

            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <h4>{{language_terms['UPLOAD_DOCUMENT']}}</h4>
                            </div>
                            <b-row>
                                <b-col cols="12">
                                    <dropzone id="myVueDropzone" 
                                            ref="myVueDropzone" 
                                            class="mb-2" 
                                            :options="dropzoneOptions" 
                                            v-on:vdropzone-sending="sendingFile" 
                                            v-on:vdropzone-removed-file ="removeImage" 
                                            > 
                                            <input type="hidden" name="token" value="xxx">
                                        </dropzone>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4" v-if="scanned_documents.length > 0">
                                <b-col cols="12">
                                    <h4>{{language_terms['SCANNED_DOCUMENTS']}}</h4>
                                </b-col>
                                <b-col cols="12">
                                    <b-table-simple striped hover responsive>
                                        <th>{{language_terms['SNO']}}</th>
                                        <th>{{language_terms['FILE_NAME']}}</th>
                                        <!-- <th>{{language_terms['TIME_UPLOADED']}}</th> -->
                                        <th>{{language_terms['USER']}}</th>
                                        <th>{{language_terms['SUPPLIER_NAME']}}</th>
                                        <th>Total Amount ($)</th>
                                        <th>Delivery Date</th>
                                        <th></th>
                                        <b-tbody>
                                            <tr v-for="(row, upload_index) in scanned_documents" :key="upload_index">
                                                <td>{{upload_index + 1}}</td>
                                                <td><a :href="row.url" target="_blank">{{row.file_name}}</a></td>
                                                <!-- <td>{{row.time_uploaded_friendly}}</td> -->
                                                <td>{{row.user_name}}</td>
                                                <td>{{row.supplier_name}}</td>
                                                <td>{{row.total_amount}}</td>
                                                <td>{{row.delivery_date}}</td>

                    <!-- $response[2]['supplier_name'] = $ocr_res[2]['supplier_name'];
                    $response[2]['ship_to'] = $ocr_res[2]['ship_to'];
                    $response[2]['total_gross_weight'] = $ocr_res[2]['total_gross_weight'];
                    $response[2]['shipment_date'] = $ocr_res[2]['shipment_date'];
                    $response[2]['shipment_number'] = $ocr_res[2]['shipment_number'];
                    $response[2]['total_dim_weight'] = $ocr_res[2]['total_dim_weight']; -->

                                                <td>
                                                    <base-button icon type="warning" size="sm" @click="deleteFile(row, upload_index)">
                                                        <i class="fa fa-trash"></i>
                                                    </base-button>
                                                </td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </card>
    
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";


import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components:{
        Loading,
        Dropzone
    },
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms
        }),
    },
    data(){
        return{
            loading:false,
            dropzoneOptions: 
            {
                maxFiles: 1,
                url: "https://httpbin.org/post",
                thumbnailWidth: 200,
                addRemoveLinks: false,
                maxFilesize: 20,
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer '+ localStorage.access_token
                    }
            },
            scanned_documents:[]
        }
    },
    methods:{
        removeImage(file){
            //console.log(file)
        },
        async deleteFile(row, index)
        {
            this.loading = true
            let upload_id = row.id
            let apiDocRemove = apiRoutes['UPLOAD_DOCUMENT_REMOVE']
            await axios.post(apiDocRemove, {upload_id:upload_id}, authHeader()).then(res => {
            if(res.data.code == 1)
            {
                alert(res.data.data)
                this.scanned_documents.splice(index, 1);
                this.loading = false
            }
        
        })
        .catch(function(){
            console.log('FAILURE!!');
        });
        },
        async sendingFile(file, xhr, formData)
        {
            this.loading = true

            let vm = this
            let apiUrl = apiRoutes['UPLOAD_DOCUMENT'];
            await axios.post(apiUrl, formData, authHeader()).then(res => 
            {
                    if (res.data.code == 1)
                    {
                        var upload_id = res.data.msg
                        var data = res.data.data 
                        vm.$refs.myVueDropzone.removeFile(file)

                        vm.scanned_documents.push(data)

                        this.loading = false
                    }
                    else
                    {
                        alert(res.data.msg)
                        vm.$refs.myVueDropzone.removeFile(file)
                    }
                })
                .catch(function()
                {
                    console.log('FAILUREAV!!');
                });

            this.loading = false
        }
    }
}
</script>
